






































































import { Filter, FilterType } from '@/utils/types'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'

@Component
export default class Filters extends Vue {
  @Prop(Array) filters!: Filter<string | number>[]

  filterType = FilterType

  handleClick (filter: Filter<number | string>, value: number | string) {
    filter.value = value
    if (filter.action) {
      filter.action(filter, value)
    }
  }

  handleClearAll () {
    this.$emit('clearAllFilters')
  }

  isFilterActive (filter: Filter<number | string>): boolean {
    if (filter.type === FilterType.RADIO) {
      return !!filter.value
    }
    if (filter.type === FilterType.CHECKBOX) {
      return filter.subItems.some(item => item.isSelected)
    }
    return false
  }
}
